<template>
	<div>
		<div class="modal-content flex">
			<div class="text_left base_padding flex_1">
				<h4>{{ $t("CompanyDetailsModal.Legal") }}</h4>
				<md-field displayOnly>
					<label>{{ $t("common.vatId") }}</label>
					<md-input :value="detail.taxNum" disabled></md-input>
				</md-field>
				<md-field displayOnly>
					<label>{{ $t("Completion.Company.Street") }}</label>
					<md-input :value="detail.street" disabled></md-input>
				</md-field>
				<md-field displayOnly>
					<label>{{ $t("common.postcode") }}</label>
					<md-input :value="detail.postcode" disabled></md-input>
				</md-field>
				<md-field displayOnly>
					<label>{{ $t("common.city") }}</label>
					<md-input :value="detail.city" disabled></md-input>
				</md-field>
				<md-field displayOnly>
					<label>{{ $t("common.country") }}</label>
					<md-input :value="formatCountry(detail.country)" disabled></md-input>
				</md-field>
				<md-field displayOnly v-if="detail.companyRegisterKey">
					<label>{{ $t("common.registrationAuthority") }}</label>
					<md-input :value="$t(detail.companyRegisterKey)" disabled></md-input>
				</md-field>
				<md-field displayOnly v-if="detail.registrationNum">
					<label>{{ $t("common.registrationNumber") }}</label>
					<md-input :value="detail.registrationNum" disabled></md-input>
				</md-field>
				<md-field displayOnly v-if="detail.incorporationTime" style="margin-bottom: 5px">
					<label>{{ $t("common.incorporationTime") }}</label>
					<md-input :value="formatAsLocalizedDate(detail.incorporationTime)" disabled></md-input>
				</md-field>
				<div v-if="detail.ratingReport" style="margin-top: 6px">
					<h5 class="info_title" style="margin-bottom: 0px">{{ $t("common.ratingReport") }}</h5>
					<a :href="getFileDownloadUrl(detail.ratingReport.fileId)" target="_blank">{{ detail.ratingReport.fileName }}</a>
				</div>
				<div v-if="detail.registerExcerpt" style="margin-top: 6px">
					<h5 class="info_title" style="margin-bottom: 0px">{{ $t("common.registerExcerpt") }}</h5>
					<a :href="getFileDownloadUrl(detail.registerExcerpt.fileId)" target="_blank">{{ detail.registerExcerpt.fileName}}</a>
				</div>
				<div v-if="detail.videoIdentPdfs && detail.videoIdentPdfs.length > 0" style="margin-top: 6px">
					<h5 class="info_title" style="margin-bottom: 0px">{{ $t("common.videoIdentReport") }}</h5>
					<a v-for="(videoIdent, index) in detail.videoIdentPdfs" :key="index" :href="getFileDownloadUrl(videoIdent.fileId)" target="_blank" style="display: block">{{videoIdent.fileName}}</a>
				</div>
			</div>
			<div class="text_left base_padding flex_1">
				<!-- General details -->
				<h4>{{ $t("CompanyDetailsModal.Details") }}</h4>
				<md-field displayOnly>
					<label :style="detail.website ? 'top: -1rem !important' : ''">{{ $t("common.website") }}</label>
					<a class="md-input" disabled target="_blank" :href=sanitizeUrl(detail.website)>
						{{ detail.website }}
					</a>
				</md-field>
				<!-- Industry -->
				<h4 class="margin_top">{{ $t("common.industry") }}</h4>
				<md-field displayOnly>
					<label>{{ $t("common.industry.section") }}</label>
					<md-textarea :value="detail.industrySection" disabled md-autogrow></md-textarea>
				</md-field>
				<md-field displayOnly>
					<label>{{ $t("common.industry.division") }}</label>
					<md-textarea :value="detail.industryDivision" disabled md-autogrow></md-textarea>
				</md-field>
				<md-field displayOnly>
					<label>{{ $t("common.industry.group") }}</label>
					<md-textarea :value="detail.industryGroup" disabled md-autogrow></md-textarea>
				</md-field>
				<md-field displayOnly>
					<label>{{ $t("common.industry.class") }}</label>
					<md-textarea :value="detail.industryClass" disabled md-autogrow></md-textarea>
				</md-field>
			</div>
		</div>
		<div class="flex flex_end base_padding">
			<md-button class="md-blank" @click.stop="closeNoticeModal">
				{{ $t("common.close") }}
			</md-button>
		</div>
	</div>
</template>
<script>
import {mapGetters} from "vuex";
import {companyApi} from "@/common/api/companyApi";
import {formatAsCountryName, formatAsIndustryText, formatAsLocalizedDate} from "@/common/format";
import {enumDef} from "@/common/enumDefs";
import {fileuploadApi} from "@/common/api/fileuploadApi";

export default {
	data() {
		return {
			detail: {},
			enumDef: enumDef,
		};
	},
	created() {
		let { data } = this.noticeModalData;
		this.loadDetails(data.companyId || data.id);
	},
	methods: {
		formatAsLocalizedDate,
		formatCountry(value) {
			return formatAsCountryName(value);
		},
		closeNoticeModal() {
			this.$store.dispatch("setActionNoticModal", { show: false, data: {} });
		},
		loadDetails(companyId) {
			companyApi
				.CompanyInfo(companyId)
				.then((res) => {
					this.detail = {
						...res,
						industrySection: formatAsIndustryText(res.industryNaceCode, { detailLevel: enumDef.industryDetailLevel.Section }),
						industryDivision: formatAsIndustryText(res.industryNaceCode, { detailLevel: enumDef.industryDetailLevel.Division }),
						industryGroup: formatAsIndustryText(res.industryNaceCode, { detailLevel: enumDef.industryDetailLevel.Group }),
						industryClass: formatAsIndustryText(res.industryNaceCode, { detailLevel: enumDef.industryDetailLevel.Class })
					};
				})
				.catch((e) => {
					this.toast(e);
				});
		},
		sanitizeUrl(url) {
			if (!url) {
				return null;
			}
			return url && url.startsWith("http") ? url : '//' + url;
		},
		getFileDownloadUrl(fileId) {
			return fileuploadApi.getPdfUrl(fileId);
		}
	},
	computed: {
		...mapGetters({
			noticeModalData: "noticeModalData",
			noticeModalShow: "noticeModalShow",
		})
	},
};
</script>
